<ng-container *ngIf="enabled$ | async">
  <ng-container *ngTemplateOutlet="gated"></ng-container>
</ng-container>
